import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EnvelopeIconSvg from './envelope-icon.svg';

// Use EnvelopeRegularIcon instead
// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EnvelopeIconSvg {...validProps} />;
}
SvgComponent.iconName = 'envelopeIcon';

/**
 * @deprecated This is a legacy icon
 */
export const EnvelopeIcon = svgIconWrapper(SvgComponent);
